import { MEMBER_PAGE } from '../../ids';
import { InstallLocation } from '../../types';
export const ids = MEMBER_PAGE;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    method: 'addSection',
    page: {
        name: t('member-pages.member-page.name'),
        shortDescription: t('member-pages.member-page.subtitle'),
        description: '',
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        origin: '',
        screenshots: [],
    },
});
//# sourceMappingURL=member-page.js.map